import { GridItem } from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useOutletContext } from 'react-router-dom';

import { useFormItems } from '../../../../hooks/formItems';
import { UserInfoContextType } from '../UserInfo';
import InformationItems, { ItemCommonProps } from './Information';
import { UserInfoState } from './UserInfoAccordion';

/**
 * 雇用・技能情報
 */
type HireAndSkillState = Pick<
  UserInfoState,
  'workerReference' | 'hiredDate' | 'firstDateOfPayRaise'
> & { workingDays: number };

/**
 * 雇用・技術情報
 * @param props -
 */
const HireAndSkillInformation: React.FunctionComponent<ItemCommonProps> = (
  props
) => {
  // const { state } = useGlobalStateMachine();
  const form = useFormContext<HireAndSkillState>();
  const { FormDatePicker, FormInputNumber, FormText } =
    useFormItems<HireAndSkillState>(form);
  const { isOutsourceMember, workingDays } =
    useOutletContext<UserInfoContextType>();

  return (
    <InformationItems name="雇用・技能" panelIndex={1}>
      <GridItem margin={2}>
        <FormText label="技能者ID" name="workerReference.expertId" />
      </GridItem>
      <GridItem margin={2}>
        <FormText label="職種" name="workerReference.workKind" />
      </GridItem>
      <GridItem margin={2}>
        <FormText
          label="主任フラグ"
          name="workerReference.chiefFlag"
          value={() =>
            form.getValues('workerReference.chiefFlag') ? '○' : '―'
          }
        />
      </GridItem>
      <GridItem hidden={props.isOutsourcer} margin={2}>
        <FormDatePicker
          label="雇入日"
          mode="view"
          name="hiredDate"
          onClickClear={() => null}
        />
      </GridItem>
      <GridItem hidden={!isOutsourceMember} margin={2}>
        <FormDatePicker
          datePickerProps={{ showYearDropdown: true, dropdownMode: 'select' }}
          label="経験開始日"
          mode={props.mode}
          name="workerReference.startDateOfExperience"
          onClickClear={(name) => form.setValue(name, '')}
          readonly={!props.isOutsourcer}
        />
      </GridItem>
      <GridItem hidden={!isOutsourceMember} margin={2}>
        {props.isOutsourcer && isOutsourceMember && props.mode === 'edit' ? (
          <FormInputNumber
            label="経験オフセット月数"
            mode={'edit'}
            name="workerReference.experienceOffsetMonths"
            numberInputProps={{ min: 0 }}
            numberInputStepperProps={{ hidden: true }}
          />
        ) : (
          <FormText
            label="経験オフセット月数"
            name="workerReference.experienceOffsetMonths"
          ></FormText>
        )}
      </GridItem>
      <GridItem hidden={props.isOutsourcer && isOutsourceMember} margin={2}>
        <FormText
          label="就業日数"
          name="workingDays"
          value={() => workingDays || '―'}
        />
      </GridItem>
      <GridItem margin={2}>
        <FormDatePicker
          label="初回昇給日"
          mode="view"
          name="firstDateOfPayRaise"
          onClickClear={() => null}
        />
      </GridItem>
      <GridItem margin={2}>
        <FormText
          label="雇入・職長・特別教育"
          name="workerReference.specialEducation"
        />
      </GridItem>
      <GridItem margin={2}>
        <FormText label="技能講習" name="workerReference.skillTraining" />
      </GridItem>
      <GridItem margin={2}>
        <FormText label="免許" name="workerReference.license" />
      </GridItem>
    </InformationItems>
  );
};

export default HireAndSkillInformation;
